import { DataBean } from "../DataBean";

export class AddCommercialCampaign extends DataBean {


    public async addCommercialCampaignItem(idCommercialCampaign: any, idProduct: any, priceValue: any, description: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.sales.CommercialCampaignItem_addCommercialCampaignItem_Number_Number_Number_String", [idCommercialCampaign, idProduct, priceValue, description]);
    }
    public async deleteCommercialCampaignItem(idCommercialCampaignItem: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteCommercialCampaignItem_Number", [idCommercialCampaignItem]);
    }

    public async getCommercialCampaignItemCatalog(idCommercialCampaign: any, idProduct: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getCommercialCampaignItemCatalog_Number_Number_Number_Number", [idCommercialCampaign, idProduct, page, recordsPerPage]);
    }

}